const admin = {
    title: 'Administration',
    description: 'Manage system settings, users, and monitor activity.',
    users: 'User Management',
    usersDescription: 'Manage users, roles, and permissions',
    groups: 'Group Management',
    categories: 'Category Management',
    tags: 'Tag Management',
    permissions: 'Permission Management',
    auditLogs: 'Audit Logs',
    auditLogsDescription: 'View system audit logs',
    settings: 'System Settings',
    settingsDescription: 'Configure system-wide settings',
    systemHealth: 'System Health',
    storage: 'Storage Management',
    storageDescription: 'Monitor storage usage and quotas',
    security: 'Security',
    securityDescription: 'Security settings and access control',
    analytics: 'Analytics',
    analyticsDescription: 'System usage analytics and reports',
    activityAudit: 'Activity Audit',
    activityAuditDescription: 'Review tenant-wide user activity in the dashboard (#579)',
    anomalies: 'Anomaly Events',
    anomaliesDescription: 'Review suspicious signals such as repeated login failures and cross-tenant access (#578)',
    noPermission: "You don't have permission to access any administrative features.",
  };

export default admin;
